export default __webpack_public_path__ + "static/ansible-94e78879e2aeedde16a6fd1dc5c0d4b6.png";